import React, { useContext, useEffect, useState } from "react";
import { useDropzone } from "react-dropzone";
import Vapor from "utils/vapor";
import _ from "lodash";
import client from "client/client";
import Button from "ui/Button";
import "./FileDropzone.scss";
import MainContext from "context/MainContext";
import { normalizeMime } from "utils/functions";
import { importSubscriptions, saveMedia } from "api/functions/functions";
import { InlineLoading, InlineNotification } from "carbon-components-react";
import FileSize from "ui/FileSize/FileSize";

const thumbsContainer = {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    marginTop: 16,
};

const thumb = {
    display: "inline-flex",
    borderRadius: 2,
    border: "1px solid #eaeaea",
    marginBottom: 8,
    marginRight: 8,
    width: 100,
    height: 100,
    padding: 4,
    boxSizing: "border-box",
};

const thumbInner = {
    display: "flex",
    minWidth: 0,
    overflow: "hidden",
};

const img = {
    display: "block",
    width: "auto",
    height: "100%",
};

function FileDropzone(props) {
    const [files, setFiles] = useState([]);
    const [total, setTotal] = useState(0);
    const [uploading, setUploading] = useState(false);
    //   const [loaded, setLoaded] = useState(false);
    const [errors, setErrors] = useState();
    const [progress, setProgress] = useState([]);
    const context = useContext(MainContext);

    useEffect(() => {
        if (context.mediaGalleryOpen) {
            // setFiles([])
            // setProgress([])
            // acceptedFiles
        }
    }, [context.mediaGalleryOpen]);

    const { acceptedFiles, fileRejections, getRootProps, getInputProps } =
        useDropzone({
            accept: normalizeMime(props.mime || context.mediaGalleryAccept),
            onDrop: (acceptedFiles) => {
                setFiles(
                    acceptedFiles.map((file) =>
                        Object.assign(file, {
                            preview: URL.createObjectURL(file),
                        })
                    )
                );
            },
        });

    const acceptedFileItems = acceptedFiles.map((file) => (
        <li key={file.path}>
            {file.path} - <FileSize size={file.size} showFeedback />
        </li>
    ));

    const fileRejectionItems = fileRejections.map(({ file, errors }) => (
        <li key={file.path}>
            {file.path} - <FileSize size={file.size} showFeedback showDanger={errors.length !== 0} />
            <ul>
                {errors.map((e) => (
                    <InlineNotification key={e.code} title={e.message} kind="error" hideCloseButton lowContrast />
                ))}
            </ul>
        </li>
    ));

    const thumbs = files.map((file) => (
        <div style={thumb} key={file.name}>
            <div style={thumbInner}>
                <img src={file.preview} style={img} />
            </div>
        </div>
    ));

    useEffect(
        () => () => {
            // Make sure to revoke the data uris to avoid memory leaks
            files.forEach((file) => URL.revokeObjectURL(file.preview));
        },
        [files]
    );

    const uploadFiles = async () => {
        if (props.onUploadingStart) {
            props.onUploadingStart();
        }
        setUploading(true);
        setErrors(null);
        let uploadProgress = [];
        files.forEach((file, index) => {
            // data.append('file_' + index, file);
            const withPermissions = context.mediaGalleryWithPermission;

            Vapor.store(file, {
                baseURL: client.defaults.baseURL,
                headers: {
                    "Content-type": file.type,
                },
                visibility: "public-read",
                contentType: file.type,
                progress: (progress) => {
                    uploadProgress[index] = Math.round(progress * 100);
                    setProgress(uploadProgress);
                },
            })
                .then(async (response) => {
                    console.log("uploadFiles", {
                        uuid: response.uuid,
                        key: response.key,
                        bucket: response.bucket,
                        name: file.name,
                        mime: file.type,
                        size: file.size,
                    });

                    let saveRes = null;
                    let postParams = {};

                    if (props.import) {
                        postParams = {
                            uuid: response.uuid,
                            key: response.key,
                            bucket: response.bucket,
                            name: file.name,
                            mime: file.type,
                            size: file.size,
                            event_id: props.eventId,
                            episode_id: props.episodeId,
                        };
                        saveRes = await importSubscriptions(
                            props.eventId,
                            postParams
                        );
                    } else {
                        postParams = {
                            uuid: response.uuid,
                            key: response.key,
                            bucket: response.bucket,
                            name: file.name,
                            mime: file.type,
                            size: file.size,
                            event_id: props.eventId,
                        };
                        if (withPermissions) {
                            postParams = {
                                ...postParams,
                                media_permission: withPermissions,
                            };
                        }
                        saveRes = await saveMedia(postParams);
                    }

                    if (props.afterUploadSuccess) {
                        props.afterUploadSuccess(saveRes, postParams);
                    }
                    // axios.post('/api/profile-photo', {
                    //     uuid: response.uuid,
                    //     key: response.key,
                    //     bucket: response.bucket,
                    //     name: this.$refs.file.files[0].name,
                    //     content_type: this.$refs.file.files[0].type,
                    // })
                })
                .catch((e) => {
                    console.log("uploadFiles", e);
                    setErrors(e);
                    // console.log("uploadFiles", e.response.data)
                })
                .finally(() => {
                    setUploading(false);
                });
        });
    };

    // No longer in use
    const uploadFiles2 = () => {
        const data = new FormData();

        const uploaderConfig = {
            // headers: {
            //   "Content-type": "application/octet-stream"
            //   // "Content-type": "multipart/form-data"
            // },
            onUploadProgress: function (progressEvent) {
                const { loadedEvt, totalEvt } = progressEvent;
                let percentCompleted = Math.round(
                    (progressEvent.loaded * 100) / progressEvent.total
                );
                setTotal(totalEvt);
                // setLoaded(loadedEvt);
                setProgress(percentCompleted);
            },
        };

        if (props.eventId) {
            data.append("event_id", props.eventId);
        }
        files.forEach((file, index) => {
            data.append("file_" + index, file);
        });

        client
            .post("media/upload", data, uploaderConfig)
            .then(function (res) {
                console.log(res.data.data);
                // if (!window._.isUndefined(res.data.data)) {
                //     thisObj.props.resetDroppedFileList();
                //     if (!window._.isUndefined(res.data.data.uploaded_files) &&
                //         !window._.isNull(res.data.data.uploaded_files)) {
                //         thisObj.props.addUploadedFilesToFileList(res.data.data.uploaded_files);
                //     }
                //     else {
                //         thisObj.props.addUploadedFilesToFileList(res.data.data);
                //     }
                //     if (!window._.isUndefined(thisObj.props.elementConfig.uploadCompleted)) {
                //         thisObj.props.elementConfig.uploadCompleted(res.data.data);
                //     }
                // }
                // component.setState({
                //     loading: false
                // });
                if (props.afterUploadSuccess) {
                    props.afterUploadSuccess(res.data.data);
                }
            })
            .catch(function (err) {
                // component.setState({
                //     loading: false
                // });
            });
    };

    const button =
        files.length > 0 ? (
            <Button onClick={() => uploadFiles()} disabled={uploading}>
                {uploading ? <InlineLoading /> : "Upload"}
            </Button>
        ) : null;

    const errorList = errors ? (
        <InlineNotification
            kind="error"
            hideCloseButton={true}
            className="inline-notification"
            title={errors ? `${errors}` : "Something went wrong"}   
        />
    ) : null;

    return (
        <section className="dropzone--container">
            <div {...getRootProps({ className: "dropzone" })}>
                <input {...getInputProps()} />
                <p>Drag 'n' drop some files here, or click to select files</p>
                <em>
                    ({context.mediaGalleryAccept && `Only `}
                    {normalizeMime(props.mime || context.mediaGalleryAccept) ||
                        "All "}
                    {" "}will be accepted)
                </em>
            </div>
            <aside>
                {!_.isEmpty(acceptedFileItems) ? (
                    <div className="upload-report">
                        <h4>Accepted files</h4>
                        <ul>{acceptedFileItems}</ul>
                    </div>
                ) : null}

                {!_.isEmpty(fileRejectionItems) ? (
                    <div className="upload-report">
                        <h4>Rejected files</h4>
                        <ul>{fileRejectionItems}</ul>
                    </div>
                ) : null}
            </aside>
            {/* <aside style={thumbsContainer}>{thumbs}</aside> */}
            <aside>
                {progress.map((item, index) => (
                    <div key={`uploaded-${index}`}>{item}%</div>
                ))}
                {/* {progress} / {total} */}
            </aside>
            <div>
                {errorList}
                {button}
            </div>
        </section>
    );
}
export default FileDropzone;
